export default function PhoneFrame({ src, alt, className = "", testId, ratio = "926 / 2009" }) {
  return (
    <div
      data-testid={testId}
      className={`relative rounded-[44px] bg-[#161514] p-[10px] shadow-[0_30px_60px_-25px_rgba(0,0,0,0.35)] ring-1 ring-black/20 ${className}`}
    >
      <div className="absolute -left-[2.5px] top-[110px] h-8 w-[3px] rounded-l-md bg-[#161514]" aria-hidden="true" />
      <div className="absolute -left-[2.5px] top-[156px] h-12 w-[3px] rounded-l-md bg-[#161514]" aria-hidden="true" />
      <div className="absolute -right-[2.5px] top-[130px] h-16 w-[3px] rounded-r-md bg-[#161514]" aria-hidden="true" />
      <div className="relative overflow-hidden rounded-[34px] bg-[#FDFBF7]" style={{ aspectRatio: ratio }}>
        <img src={src} alt={alt} loading="lazy" className="absolute inset-0 h-full w-full object-contain" />
      </div>
    </div>
  );
}
